<style>
  div.form-text--radio {
    min-width: 50%;
    text-justify: inter-word;
  }

  input[type="radio"] {
    position: relative;
    /* transform: scale(1.2);  */
    padding: 0.5rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    box-sizing: content-box;
    width: 38px;
  }
  input[type="radio"]:hover::after {
    position: absolute;
    content: '';
    background-color: rgba(1, 1, 34, 0.158);
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    border-radius: 50%;
  }
  .inline-form {
    align-items: center;
  }
</style>

<h4>Demographics</h4>
<h6>Hover over section requirements for further information</h6>


<div class="lump-solid--form">
  <KeyWords bind:keyWords={demographic.keyWords}/>
  <p></p>
  <div class="Tooltip">Age Range <span class="required--input">(*)</span>
  <span class="Tooltiptext">This is your targeted age range. </span>
  </div>
  <div class="lump-dashed--form">
    <div class="form-group">
      <input
        class="form-control"
        type="number"
        id="lower-bound-age-input"
        placeholder="Lower Bound Age"
        bind:value={demographic.age.lowerBound}
        required
      />
    </div>
    <div class="form-group">
      <input
        class="form-control"
        type="number"
        id="upper-bound-age-input"
        placeholder="Upper Bound Age"
        bind:value={demographic.age.upperBound}
        required
      />
    </div>
  </div>
  <p></p>
  <div class="Tooltip">Socioeconomic Range <span class="required--input">(*)</span>
    <span class="Tooltiptext">This is the annual income range of your target audience.</span>
  </div>
  <div class="lump-dashed--form">
    <div class="form-group">
      <input
        class="form-control"
        type="number"
        id="lower-bound-socioeconomic-input"
        placeholder="Lower Bound Income in Dollars"
        bind:value={demographic.socioEconomic.lowerBound}
        required
      />
    </div>
    <div class="form-group">
      <input
        class="form-control"
        type="number"
        id="upper-bound-socioeconomice-input"
        placeholder="Upper Bound Income in Dollars"
        bind:value={demographic.socioEconomic.upperBound}
        required
      />
    </div>
  </div>
  <p></p>
  <p></p>
  <div class="Tooltip">Gender
  <span class="Tooltiptext">Are you aiming more towards females or males? If you have no preference, please select both</span>
  </div>
  <p></p>
  <div class="form-group inline-form">
    <div class="form-text--radio">
    Females
    </div>
    <!-- Group of material radios - option Female true -->
    <div class="form-group inline-form">
      <input
        type="radio"
        class="form-check-input"
        id="femaleCheckedTrue"
        name="femaleDemGroup"
        on:click={() => demographic.gender.targetFemale = true}
        checked
      />
      <div>True</div>
    </div>

    <!-- Group of material radios - option 2 -->
    <div class="form-group inline-form">
      <input
        type="radio"
        class="form-check-input"
        id="femaleCheckedFalse"
        name="femaleDemGroup"
        on:click={() => demographic.gender.targetFemale = false}
      />
      <div>False</div>
    </div>
  </div>
  <div class="form-group inline-form">
      <div class="form-text--radio">
        Males
      </div>
      <!-- Group of material radios - option Female true -->
      <div class="form-group inline-form">
        <input
          type="radio"
          class="form-check-input"
          id="maleCheckedTrue"
          name="maleDemGroup"
          on:click={() => demographic.gender.targetMale = true}
          checked
        />
        <div>True</div>
      </div>
  
      <!-- Group of material radios - option 2 -->
      <div class="form-group inline-form">
        <input
          type="radio"
          class="form-check-input"
          id="maleCheckedFalse"
          name="maleDemGroup"
          on:click={() => {demographic.gender.targetMale = false}}
        />
        <div>False</div>
      </div>
    </div>
</div>
<script>
  import KeyWords from "./KeyWords.svelte";
  import getDemographicsModel from "../../../js-core/models/demographics"
  export let demographic = getDemographicsModel()
  export let isAdOwner
  export let isTvOwner
</script>